import {travianFeatures} from "../../travianCore";

export function legendsSquashDistance(distance, heroBoots, tournamentSquare) {
    return distance <= 20 ? distance : (20 + (distance - 20) / (1 + heroBoots + tournamentSquare * 0.2));
}

export function calculateTravelTime({
                                        distance,
                                        baseSpeed,
                                        tournamentSquare = 0,
                                        heroBoots = 0,
                                        heroStandard = 0,
                                        heroMap = 0,
                                        artefact = 1,
                                        isSiege = false,
                                        hunSpeedBonus = false,
                                        gaulSpeedBonus = false,
                                        serverTroopSpeed = travianFeatures.troopSpeed,
                                        travianBaseVersion = +travianFeatures.baseVersion,
                                    }) {
    switch (travianBaseVersion) {
        case 4:
            // T:L has no siege
            // Also TSquare gives 20% per level.
            const modifiedBaseSpeed = (baseSpeed + (hunSpeedBonus ? 3 : 0) + (gaulSpeedBonus ? 5 : 0));
            const modifiedSpeed = modifiedBaseSpeed * artefact * serverTroopSpeed * (1 + heroStandard + heroMap);
            const modifiedDistance = legendsSquashDistance(distance, heroBoots, tournamentSquare);
            return modifiedSpeed === 0 ? 1 : Math.round(3600 * modifiedDistance / modifiedSpeed);

        case 5:
            // TK has no artefacts
            // Also TSquare gives 10% per level.
            // TK has this super fucked up calculation method ...
            const boosts = [];
            boosts.push(1 + heroStandard);
            boosts.push(1 + heroMap);
            if (distance > 20) {
                boosts.push(distance / (20 + (distance - 20) / (1 + tournamentSquare / 10)));
                boosts.push(distance / (20 + (distance - 20) / (1 + heroBoots)));
            }
            const finalBoost = boosts.reduce((a, b) => a * b, 1);
            return Math.round(3600 * distance / (baseSpeed * finalBoost * serverTroopSpeed) * (isSiege ? 2 : 1));

        default:
            throw new Error('No calculator for this Travian version!');
    }
}

export function reverseCalculate({
                                     distance,
                                     possibleBaseSpeeds,
                                     travelTimeMin,
                                     travelTimeMax,
                                     tournamentSquareMin = 0,
                                     tournamentSquareMax = 20,
                                     heroBoots = 0,
                                     heroStandard = 0,
                                     heroMap = 0,
                                     artefact = 1,
                                     isSiege = false,
                                     serverTroopSpeed = travianFeatures.troopSpeed,
                                     travianBaseVersion = +travianFeatures.baseVersion,
                                 }) {
    if(distance <= 20) {
        tournamentSquareMin = tournamentSquareMax = 0;
    }
    const possibleCombinations = [];
    for (let baseSpeed of possibleBaseSpeeds) {
        for (let tournamentSquare = tournamentSquareMin; tournamentSquare <= tournamentSquareMax; tournamentSquare++) {
            const travelTime = calculateTravelTime({
                distance,
                baseSpeed,
                tournamentSquare,
                heroBoots,
                heroStandard,
                heroMap,
                artefact,
                isSiege,
                serverTroopSpeed,
                travianBaseVersion
            });
            if (travelTimeMin <= travelTime && travelTime <= travelTimeMax) {
                possibleCombinations.push({
                    baseSpeed,
                    tournamentSquare
                });
            }
        }
    }
    return possibleCombinations;
}
